import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetDriversToAssignQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetDriversToAssignQuery = { __typename?: 'query_root', drivers: Array<{ __typename?: 'drivers', id: number, status: string, user?: { __typename?: 'users', id: number, avatar_url?: string | null, display_name: string } | null }> };


export const GetDriversToAssignDocument = gql`
    query getDriversToAssign($customerId: bigint!) {
  drivers(
    where: {user: {active: {_eq: true}, users_usertocustomers: {customer_id: {_eq: $customerId}}, users_usertoroles: {roletype: {name: {_eq: "driver"}}}}}
    order_by: {user: {display_name: asc}}
  ) {
    id
    status
    user {
      id
      avatar_url
      display_name
    }
  }
}
    `;

/**
 * __useGetDriversToAssignQuery__
 *
 * To run a query within a React component, call `useGetDriversToAssignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriversToAssignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriversToAssignQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetDriversToAssignQuery(baseOptions: Apollo.QueryHookOptions<GetDriversToAssignQuery, GetDriversToAssignQueryVariables> & ({ variables: GetDriversToAssignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriversToAssignQuery, GetDriversToAssignQueryVariables>(GetDriversToAssignDocument, options);
      }
export function useGetDriversToAssignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriversToAssignQuery, GetDriversToAssignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriversToAssignQuery, GetDriversToAssignQueryVariables>(GetDriversToAssignDocument, options);
        }
// @ts-ignore
export function useGetDriversToAssignSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDriversToAssignQuery, GetDriversToAssignQueryVariables>): Apollo.UseSuspenseQueryResult<GetDriversToAssignQuery, GetDriversToAssignQueryVariables>;
export function useGetDriversToAssignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDriversToAssignQuery, GetDriversToAssignQueryVariables>): Apollo.UseSuspenseQueryResult<GetDriversToAssignQuery | undefined, GetDriversToAssignQueryVariables>;
export function useGetDriversToAssignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDriversToAssignQuery, GetDriversToAssignQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDriversToAssignQuery, GetDriversToAssignQueryVariables>(GetDriversToAssignDocument, options);
        }
export type GetDriversToAssignQueryHookResult = ReturnType<typeof useGetDriversToAssignQuery>;
export type GetDriversToAssignLazyQueryHookResult = ReturnType<typeof useGetDriversToAssignLazyQuery>;
export type GetDriversToAssignSuspenseQueryHookResult = ReturnType<typeof useGetDriversToAssignSuspenseQuery>;
export type GetDriversToAssignQueryResult = Apollo.QueryResult<GetDriversToAssignQuery, GetDriversToAssignQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/components/Modals/queries/getDriversToAssign.query.gql}
 */
export async function getDriversToAssign(
  variables: GetDriversToAssignQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetDriversToAssignQuery['drivers']>
export async function getDriversToAssign(
  variables: GetDriversToAssignQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetDriversToAssignQuery>
export async function getDriversToAssign(
  variables: GetDriversToAssignQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetDriversToAssignQuery['drivers'] | GetDriversToAssignQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetDriversToAssignQuery>(
    GetDriversToAssignDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.drivers
}